<!-- Desktop Sidebar -->
<div *ngIf="!isTreasurePickRoute()" class="sidebar-container" [class.sidebar-landing]="mode === 'landing'" [class.sidebar-open]="isSidebarOpen" [class.sidebar-closed]="!isSidebarOpen">
  <div class="sidebar-inner">

    <!-- ===== Guest / Landing view ===== -->
    <ng-container *ngIf="mode === 'landing'">
      <div class="sb-section">
        <span class="sb-section-label">MAIN</span>
        <nav class="sb-nav">
          <!-- Dashboard -->
          <a class="sb-link" (click)="goToLandingDashboard()" [class.active]="isLandingSectionActive('dashboard')">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
            Dashboard
          </a>

          <!-- Trending Games -->
          <a class="sb-link" (click)="goToTrendingGames()" [class.active]="isLandingSectionActive('trending')">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
            </svg>
            Trending Games
          </a>
        </nav>
      </div>

      <div class="sb-section">
        <span class="sb-section-label">LEGAL</span>
        <nav class="sb-nav">
          <a class="sb-link-sm" (click)="goToPrivacyPolicy()" [class.active]="isLandingSectionActive('privacy')">Privacy Policy</a>
          <a class="sb-link-sm" (click)="goToTermsAndConditions()" [class.active]="isLandingSectionActive('terms')">Terms &amp; Conditions</a>
        </nav>
      </div>

      <div class="sb-footer">
        <button class="sb-btn-primary" (click)="onCreateAccount()">Create Account</button>
        <button class="sb-btn-ghost" (click)="onSignIn()">Sign In</button>
      </div>
    </ng-container>

    <!-- ===== Logged-in / Dashboard view ===== -->
    <ng-container *ngIf="mode === 'dashboard'">
    <div class="sb-section">
      <span class="sb-section-label">MAIN</span>
      <nav class="sb-nav">
        <!-- Dashboard -->
        <a class="sb-link" routerLink="/dashboard/home" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
          Dashboard
        </a>

        <!-- My Games -->
        <a class="sb-link" routerLink="/dashboard/account" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8M7 18a4 4 0 01-4-4V8a4 4 0 014-4h10a4 4 0 014 4v6a4 4 0 01-4 4H7z"></path>
          </svg>
          My Games
        </a>

        <!-- Spin & Win -->
        <a class="sb-link" routerLink="/dashboard/spinner" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0v9l6 3"></path><circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"></circle>
          </svg>
          Spin &amp; Win
        </a>

        <!-- Wallet -->
        <a class="sb-link" routerLink="/dashboard/wallet" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
          </svg>
          Wallet
        </a>

        <!-- Trending Games -->
        <a class="sb-link" routerLink="/dashboard/quick-games" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
          </svg>
          Trending Games
        </a>
      </nav>
    </div>

    <div class="sb-section">
      <span class="sb-section-label">ACCOUNT</span>
      <nav class="sb-nav">
        <!-- My Profile -->
        <a class="sb-link" routerLink="/dashboard/profile" routerLinkActive="active" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          My Profile
        </a>

        <!-- Notifications -->
        <!-- <a class="sb-link" (click)="closeSidebar()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
          Notifications
        </a> -->
      </nav>
    </div>

    <div class="sb-section">
      <span class="sb-section-label">LEGAL</span>
      <nav class="sb-nav">
        <a class="sb-link-sm" routerLink="/dashboard/PrivacyPolicy" routerLinkActive="active" (click)="closeSidebar()">Privacy Policy</a>
        <a class="sb-link-sm" routerLink="/dashboard/Terms&Conditions" routerLinkActive="active" (click)="closeSidebar()">Terms &amp; Conditions</a>
      </nav>
    </div>

    <!-- Footer -->
    <div class="sb-footer-user">
      <div class="sb-user-card">
        <span class="sb-avatar">
          <img [src]="profileImage" alt="Profile" />
        </span>
        <div class="sb-user-meta">
          <span class="sb-user-name">{{ userName }}</span>
          <span class="sb-user-role">USER</span>
        </div>
        <button class="sb-logout" aria-label="Sign out" (click)="showLogoutModal()">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
        </button>
      </div>
    </div>
    </ng-container>
  </div>
</div>

<!-- Mobile Overlay -->
<div *ngIf="isSidebarOpen && isMobile" class="sidebar-overlay" (click)="closeSidebar()"></div>

<!-- Mobile Sidebar -->
<div *ngIf="isMobile && !isTreasurePickRoute()" class="sidebar-mobile" [class.sidebar-landing]="mode === 'landing'" [class.mobile-open]="isSidebarOpen" [class.mobile-closed]="!isSidebarOpen">
  <div class="sidebar-inner">

    <!-- ===== Mobile Guest / Landing view ===== -->
    <ng-container *ngIf="mode === 'landing'">
      <div class="sb-section">
        <span class="sb-section-label">MAIN</span>
        <nav class="sb-nav">
          <a class="sb-link" (click)="goToLandingDashboard(); closeSidebarMobile()" [class.active]="isLandingSectionActive('dashboard')">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
            Dashboard
          </a>
          <a class="sb-link" (click)="goToTrendingGames(); closeSidebarMobile()" [class.active]="isLandingSectionActive('trending')">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
            </svg>
            Trending Games
          </a>
        </nav>
      </div>
      <div class="sb-section">
        <span class="sb-section-label">LEGAL</span>
        <nav class="sb-nav">
          <a class="sb-link-sm" (click)="goToPrivacyPolicy(); closeSidebarMobile()" [class.active]="isLandingSectionActive('privacy')">Privacy Policy</a>
          <a class="sb-link-sm" (click)="goToTermsAndConditions(); closeSidebarMobile()" [class.active]="isLandingSectionActive('terms')">Terms &amp; Conditions</a>
        </nav>
      </div>
      <div class="sb-footer">
        <button class="sb-btn-primary" (click)="onCreateAccount(); closeSidebarMobile()">Create Account</button>
        <button class="sb-btn-ghost" (click)="onSignIn(); closeSidebarMobile()">Sign In</button>
      </div>
    </ng-container>

    <!-- ===== Mobile Logged-in view ===== -->
    <ng-container *ngIf="mode === 'dashboard'">
    <div class="sb-section">
      <span class="sb-section-label">MAIN</span>
      <nav class="sb-nav">
        <a class="sb-link" routerLink="/dashboard/home" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
          Dashboard
        </a>
        <a class="sb-link" routerLink="/dashboard/account" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8M7 18a4 4 0 01-4-4V8a4 4 0 014-4h10a4 4 0 014 4v6a4 4 0 01-4 4H7z"></path>
          </svg>
          My Games
        </a>
        <a class="sb-link" routerLink="/dashboard/spinner" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0v9l6 3"></path><circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"></circle>
          </svg>
          Spin &amp; Win
        </a>
        <a class="sb-link" routerLink="/dashboard/wallet" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
          </svg>
          Wallet
        </a>
        <a class="sb-link" routerLink="/dashboard/quick-games" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
          </svg>
          Trending Games
        </a>
      </nav>
    </div>
    <div class="sb-section">
      <span class="sb-section-label">ACCOUNT</span>
      <nav class="sb-nav">
        <a class="sb-link" routerLink="/dashboard/profile" routerLinkActive="active" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          My Profile
        </a>
        <!-- <a class="sb-link" (click)="closeSidebarMobile()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
          Notifications
        </a> -->
      </nav>
    </div>
    <div class="sb-section">
      <span class="sb-section-label">LEGAL</span>
      <nav class="sb-nav">
        <a class="sb-link-sm" routerLink="/dashboard/Terms&Conditions" routerLinkActive="active" (click)="closeSidebarMobile()">Privacy Policy</a>
        <a class="sb-link-sm" routerLink="/dashboard/Terms&Conditions" routerLinkActive="active" (click)="closeSidebarMobile()">Terms &amp; Conditions</a>
      </nav>
    </div>
    <div class="sb-footer-user">
      <div class="sb-user-card">
        <span class="sb-avatar">
          <img [src]="profileImage" alt="Profile" />
        </span>
        <div class="sb-user-meta">
          <span class="sb-user-name">{{ userName }}</span>
          <span class="sb-user-role">USER</span>
        </div>
        <button class="sb-logout" aria-label="Sign out" (click)="showLogoutModal(); closeSidebarMobile()">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
        </button>
      </div>
    </div>
    </ng-container>
  </div>
</div>

<app-logoutmodel [isOpen]="isLogoutModalOpen" [profileImage]="profileImage" (onCancel)="closeLogoutModal()" (onConfirm)="logout()"></app-logoutmodel>
